import { render, staticRenderFns } from "./PackageSearchButton.vue?vue&type=template&id=8c1e04b6&"
import script from "./PackageSearchButton.vue?vue&type=script&lang=js&"
export * from "./PackageSearchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports